import { render, staticRenderFns } from "./OrgLicenseManager.vue?vue&type=template&id=a70724b8"
import script from "./OrgLicenseManager.vue?vue&type=script&lang=js"
export * from "./OrgLicenseManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports